import type { FarmConfig } from "@/constants/project-specific/farms/types";

export const getPoolName = (farm: FarmConfig): string => {
    return `${farm.tokenA.symbol}${farm.tokenB && farm.tokenB.name !== undefined ? `-${farm.tokenB.symbol}` : ''}`;
}